// Firebase configuration
import { FirebaseError, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

import devConfig from '@/config/firebase.config.dev';
import prodConfig from '@/config/firebase.config.prod';
console.log("meta.env", import.meta.env)
const firebaseConfig = import.meta.env.MODE === 'development' ? devConfig : prodConfig;

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { app, auth };